<div class="product-item">
  @if (quantity > 0) {
    <div
      class="image-container"
      [matBadge]="quantity"
      matBadgePosition="above after"
      matBadgeColor="primary"
    >
      <img
        [src]="product.imageThumbUrl"
        alt="{{ product.productTitle }}"
        class="product-image"
      />
    </div>
  } @else {
    <div class="image-container">
      <img
        [src]="product.imageThumbUrl"
        alt="{{ product.productTitle }}"
        class="product-image"
      />
    </div>
  }
  <h3 class="product-title" [title]="product.productTitle">
    {{ product.productTitle }}
  </h3>
  <div class="button-container">
    @if (!isSelected && product.availability.toString() === "InStock") {
      <button
        mat-raised-button
        color="primary"
        class="shrink-2x"
        (click)="incrementQuantity()"
        [disabled]="isIncrementDisabled()"
      >
        Add
      </button>
    } @else if (
      !isSelected && product.availability.toString() === "OutOfStock"
    ) {
      <span class="out-of-stock-label">Out of Stock</span>
    } @else {
      <div class="quantity-buttons">
        <button
          mat-icon-button
          color="primary"
          (click)="decrementQuantity()"
          [disabled]="isDecrementDisabled()"
        >
          <mat-icon>remove</mat-icon>
        </button>
        <span class="quantity-number">{{ quantity }}</span>
        <button
          mat-icon-button
          color="primary"
          (click)="incrementQuantity()"
          [disabled]="isIncrementDisabled()"
        >
          <mat-icon>add</mat-icon>
        </button>
      </div>
    }
  </div>
</div>
